import i18n from 'i18next'; import { initReactI18next } from 'react-i18next'; import ru from './locales/ru.json'; import en from './locales/en.json';
i18n.use(initReactI18next).init({ resources: { ru: { translation: ru }, en: { translation: en } }, lng: localStorage.getItem('gc-language') || 'ru', fallbackLng: 'ru', interpolation: { escapeValue: false } });
document.documentElement.lang = i18n.language.startsWith('en') ? 'en' : 'ru';
export default i18n;
